import { useMutation, useQueryClient } from '@tanstack/react-query';
import cn from 'classnames';
import { Billing } from '#api';
import { billingDetailsQueryOptions } from '#api/billing.queries.ts';
import { StripeWordmarkBlurple } from '#assets/ReactSvg.ts';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { DetailCard } from '#components/atoms/cards/detail-card/DetailCard.tsx';
import styles from './ManageBillingCard.module.css';

export function ManageBillingCard() {
  const queryClient = useQueryClient();

  const customerPortalMutation = useMutation({
    mutationFn: Billing.showCustomerPortal,
  });

  const handleManageBilling = async () => {
    const { redirectURL } = await customerPortalMutation.mutateAsync();
    void queryClient.invalidateQueries(billingDetailsQueryOptions);
    document.location = redirectURL;
  };

  return (
    <DetailCard className={cn('flex flex-wrap justify-between align-center gap-16', styles.ManageBillingCard)}>
      <div>
        <h2 className="h4 flex gap-4 mb-8">
          Billing managed by{' '}
          <StripeWordmarkBlurple height="1.2em" width={`${1.2 * (58 / 24)}em`} style={{ aspectRatio: '58 / 24' }} />
        </h2>
        <p className="p-md mb-0">
          Update your payment method, billing email, or address in the Stripe customer portal.
        </p>
      </div>
      <Button onClick={handleManageBilling} variant="secondary">
        Manage account
      </Button>
    </DetailCard>
  );
}
